import React from "react";
import {
  ActiveStarIcon,
  DeleteIcon,
  DownloadIcon,
  fileIcons,
  RestoreIcon,
  StarIcon,
} from "../Icons";
import { format } from "date-fns";
import { downloadFile, downloadFolder, formatFileSize } from "../utils/utils";
import Tooltip from "@mui/material/Tooltip";
import SecondaryFolder from "./SecondaryFolder";
import NoFiles from "./EmptyList/NoFiles";
import ActionPopup from "./ActionPopup";
import FileBulkActionBar from "./Mobile/FileBulkActionBar";

const GridView = ({
  token,
  restoreFile,
  handleDelete,
  isBin = false,
  files,
  folders,
  changeFav,
  currentFolder,
  previewFile,
  folderClickFromView,
  totalFiles = 0,
  totalFolders = 0,
  handleRename,
  handleMove,
  selectedKeys,
  setSelectedKeys,
}) => {
  const handleFolderDownload = async (id) => {
    downloadFolder(token, id);
  };

  const toggleRow = (key) => {
    const next = selectedKeys.includes(key)
      ? selectedKeys.filter((k) => k !== key)
      : [...selectedKeys, key];
    setSelectedKeys(next);
  };

  return (
    <>
      {!isBin && (
        <>
          {+currentFolder?.id !== 2 && (
            <>
              <div className="text-black text-[1rem] font-medium my-3">
                {`Folders (${totalFolders})`}
              </div>
              {folders?.length > 0 ? (
                <>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 my-3">
                    {folders?.map((folder) => (
                      <SecondaryFolder
                        changeFav={changeFav}
                        downloadClick={handleFolderDownload}
                        folder={folder}
                        label={folder?.folder_name}
                        isFav={folder?.is_favorite}
                        folderClickFromView={folderClickFromView}
                      />
                    ))}
                  </div>
                </>
              ) : (
                <NoFiles
                  primaryLabel="No Folders Found"
                  secondaryLabel="Folders will appear here once they are added"
                />
              )}
            </>
          )}
        </>
      )}

      {+currentFolder?.id !== 1 && (
        <>
          <div
            className={`text-black text-[1rem] font-medium my-3 ${
              !isBin ? "mt-5" : ""
            }`}
          >
            {`Files (${totalFiles})`}
          </div>
          {selectedKeys?.length > 0 && window.innerWidth < 768 && (
            <FileBulkActionBar
              data={files}
              handleDelete={handleDelete}
              selectedKeys={selectedKeys}
              setSelectedKeys={setSelectedKeys}
              handleFav={changeFav}
              handleRestore={restoreFile}
            />
          )}
          {files?.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 my-3">
              <>
                {files?.map((file) => {
                  const FileIcon = fileIcons?.[file.file_type],
                    isManual = file?.["upload_type"] === "Manual",
                    isSelected = selectedKeys?.includes(file?.id);
                  return (
                    <button
                      onClick={() => previewFile?.(file)}
                      className="border border-[#E0E1DE] p-3 rounded-[15px] flex flex-col items-stretch bg-transparent"
                    >
                      {isBin ? (
                        <div className="flex items-center justify-between">
                          {window.innerWidth < 768 && (
                            <input
                              type="checkbox"
                              // onChange={() => toggleRow(key)}
                              checked={isSelected}
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleRow(file?.id);
                              }}
                              style={{
                                // accentColor: "#6366f1",
                                width: 15,
                                height: 15,
                                cursor: "pointer",
                              }}
                            />
                          )}
                          {/* <div className="flex gap-2 items-center w-full"> */}
                          <div className="flex items-center gap-1 w-[80%] max-w-[80%]">
                            {FileIcon && <FileIcon w="10" h="15" />}
                            <span
                              title={file?.file_name}
                              className="text-left font-normal truncate max-w-[85%] text-[0.9rem] lg:text-[0.82rem] text-[#232323]"
                            >
                              {file?.["file_name"]}
                            </span>
                          </div>
                          {/* </div> */}
                          {window.innerWidth >= 768 ? (
                            <div className="flex items-center gap-2">
                              <Tooltip
                                title="Restore File"
                                placement="top-start"
                              >
                                <button
                                  className="border-none bg-transparent p-0 m-0"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    restoreFile(file);
                                  }}
                                >
                                  <RestoreIcon w="13" h="13" />
                                </button>
                              </Tooltip>
                              <Tooltip
                                title="Delete Permanently"
                                placement="top-start"
                              >
                                <button
                                  className="border-none bg-transparent p-0 m-0"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDelete(file);
                                  }}
                                >
                                  <DeleteIcon w="12" h="14" />
                                </button>
                              </Tooltip>
                            </div>
                          ) : (
                            <ActionPopup
                              move={handleMove}
                              rename={handleRename}
                              file={file}
                              handleDelete={handleDelete}
                              favourite={changeFav}
                              handleRestore={restoreFile}
                              isBin={true}
                            />
                          )}
                        </div>
                      ) : (
                        <div className="flex items-center justify-between w-full">
                          <div className="flex gap-2 items-center w-[90%] lg:w-[80%]">
                            {window.innerWidth < 768 && (
                              <input
                                type="checkbox"
                                // onChange={() => toggleRow(key)}
                                checked={isSelected}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleRow(file?.id);
                                }}
                                style={{
                                  // accentColor: "#6366f1",
                                  width: 15,
                                  height: 15,
                                  cursor: "pointer",
                                }}
                              />
                            )}
                            {file?.is_favorite ? (
                              <Tooltip
                                title="Remove from favourites"
                                placement="top-start"
                              >
                                <button
                                  className="border-none bg-transparent p-0"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    changeFav(file);
                                  }}
                                >
                                  <ActiveStarIcon w="15" h="15" />
                                </button>
                              </Tooltip>
                            ) : (
                              <Tooltip
                                title="Add to favourites"
                                placement="top-start"
                              >
                                <button
                                  className="border-none bg-transparent p-0"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    changeFav(file);
                                  }}
                                >
                                  <StarIcon />
                                </button>
                              </Tooltip>
                            )}
                            <div className="flex items-center gap-1 w-[85%] max-w-[85%]">
                              {FileIcon && <FileIcon w="10" h="15" />}
                              <span
                                title={file?.["file_name"]}
                                className="text-left font-normal truncate w-[95%] text-[0.9rem] lg:text-[0.82rem] text-[#232323]"
                              >
                                {file?.["file_name"]}
                              </span>
                            </div>
                          </div>
                          {isManual ? (
                            <ActionPopup
                              move={handleMove}
                              rename={handleRename}
                              file={file}
                              download={downloadFile}
                              handleDelete={handleDelete}
                              favourite={changeFav}
                            />
                          ) : (
                            <Tooltip
                              title="Download File"
                              placement="top-start"
                            >
                              <button
                                className="border-none bg-transparent"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  downloadFile(file?.s3_url, file?.file_name);
                                }}
                              >
                                <DownloadIcon />
                              </button>
                            </Tooltip>
                          )}
                        </div>
                      )}
                      <div className="flex justify-center items-center px-6 py-8">
                        {FileIcon && <FileIcon w="30" h="35" />}
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="font-normal text-[0.8rem] lg:text-[0.7rem] text-neutral-600">
                          {format(new Date(file?.updated_at), "dd/MM/yy")}
                        </span>
                        <span className="font-normal text-[0.8rem] lg:text-[0.7rem] text-neutral-600">
                          {formatFileSize(file?.file_size)}
                        </span>
                      </div>
                    </button>
                  );
                })}
              </>
            </div>
          ) : (
            <NoFiles />
          )}
        </>
      )}
    </>
  );
};

export default GridView;
